import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  ${props => props.theme.gap(5)};
  margin-top: ${props => props.theme.space(9)};

  ${mediaMin.mediumBreakpoint`
    flex-direction: column;
    ${props => props.theme.gap(3, 'column')};
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.theme.gap(3, 'column')};
  max-height: 100%;

  p {
    font-size: ${props => props.theme.rem(16)};
    color: ${props => props.theme.availabilitySection.description.color};
    font-weight: 600;

    span {
      display: inline-block;
      min-width: 150px;
      font-weight: 400;
    }
  }
`;
